<template>
  <el-dialog
    :title="showTitle"
    :visible.sync="dialogVisible"
    width="480px"
    custom-class="update-course-time-dialog"
    :before-close="handleClosed"
    :show-close="step !== 0"
  >
    <div class="update-course-content">
      <!-- 模版一 -->
      <template v-if="step === 0">
        <div class="update-course-rule">
          <div class="rule-content" v-html="ruleContent" />
          <div class="rule-content-btn">
            <el-button
              class="book-course-btn confirm-btn"
              type="primary"
              @click="confirm"
              :disabled="countdown > 0"
            >
              {{ countdown > 0 ? `我知道了 ${countdown}s` : '我知道了' }}
            </el-button>
          </div>
        </div>
      </template>
      <!-- 4: 调换单课节 -->
      <template v-if="step === 4">
        <div class="book-course-name">
          <BookCourseRuleAlert @onClick="handleShowRule" />
          <h3>调换课节名称</h3>
          <el-select
            v-model="periodId"
            placeholder="请选择课节"
            popper-class="update-course-time-popper"
            class="lesson-select"
          >
            <el-option
              v-for="item in lessonOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <div class="period-tip" v-if="restCount !== -1">
            已开课节还可调换
            <span class="red-tip">{{ restCount }}</span>
            次
          </div>
        </div>
        <div class="book-course-time">
          <h3>选择上课时间</h3>
          <el-select
            v-model="selectedTimeSlot"
            :disabled="!timeSlotOptions.length"
            placeholder="选择上课时段"
            popper-class="update-course-time-popper"
            class="time-select"
            @change="handleTimeSelectChange"
          >
            <el-option
              v-for="item in timeSlotOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :timeData="item.timeData"
            >
            </el-option>
          </el-select>
          <div class="time-tip" v-if="timeTip">{{ timeTip }}</div>
        </div>
        <div class="dialog-footer">
          <el-button class="book-course-btn cancel-btn" @click="cancelStep4">取消</el-button>
          <el-button
            class="book-course-btn confirm-btn"
            type="primary"
            @click="confirmStep4"
            :disabled="!periodId || !selectedTimeSlot"
          >
            确定调整
          </el-button>
        </div>
      </template>
      <!-- 1: 课程未开课，批量改 -->
      <template v-if="step === 1">
        <div class="book-course-name">
          <h3>课程名称</h3>
          <CourseSelector
            :selectedCourse="selectedCourse"
            :courses="courses"
            :isBatchBook="isBatchBook"
            @onChange="onCourseChange"
          />
        </div>
        <div class="book-course-time">
          <h3>选择上课时间</h3>
          <el-cascader
            :disabled="!durationGroups.length"
            popper-class="time-cascader-popper"
            separator="  "
            v-model="selectedTime"
            :options="formattedTimeOptions"
            :props="cascaderProps"
            placeholder="选择上课时间"
            clearable
            class="time-cascader"
          ></el-cascader>
          <div class="time-tip" v-if="timeTip">{{ timeTip }}</div>
        </div>
        <div class="dialog-footer">
          <el-button class="book-course-btn cancel-btn" @click="cancelStep1">取消</el-button>
          <el-button
            class="book-course-btn confirm-btn"
            type="primary"
            @click="confirmStep1"
            :disabled="!selectedTime.length"
          >
            确定调整
          </el-button>
        </div>
      </template>

      <!-- 2: 确定上课时间 -->
      <template v-if="step === 2">
        <div class="comfirm-time-cont">
          <div>调换至{{ showDayInfo }}</div>
          <div>{{ `${showDateInfo}上课` }}</div>
        </div>
        <div class="dialog-footer">
          <el-button class="book-course-btn cancel-btn" @click="cancelStep2">取消</el-button>
          <el-button class="book-course-btn confirm-btn" type="primary" @click="confirmStep2">
            确定调整
          </el-button>
        </div>
      </template>
      <!-- 3: 调换成功 -->
      <template v-if="step === 3">
        <div class="book-success">
          <div class="book-success-icon">
            <img
              width="72"
              height="48"
              src="@/assets/images/member/book-course/book-success.png"
              alt="success"
            />
          </div>
          <div class="book-success-text">
            <div class="book-success-text-title">调换成功</div>
            <div class="book-success-text-desc">课程时间已更新，请按时上课</div>
          </div>
        </div>
      </template>
    </div>
  </el-dialog>
</template>

<script>
import { UPDATE_COURSE_TIME_IDENTITY, BOOK_STATUS } from '../config';
import CourseSelector from './CourseSelector';
import { BOOK_OPERATION, BOOK_FAIL_TYPE } from '../config';
import BookCourseRuleAlert from './BookCourseRuleAlert';

export default {
  name: 'BookCourseDialog',
  customModifiers: {
    'click.debounce.300': 'confirmStep4', // 添加延迟时间 300ms
    'click.debounce.301': 'confirmStep1', // 添加延迟时间 300ms
    'click.debounce.302': 'confirmStep2', // 添加延迟时间 300ms
  },
  components: {
    CourseSelector,
    BookCourseRuleAlert,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    courses: {
      type: Array,
      default: () => [],
    },
    currentCourse: {
      type: Object,
      default: () => {},
    },
    isBatchBook: {
      type: Boolean,
      default: true,
    },
    bookStatus: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      restCount: -1,
      showTitle: '调换上课时间',
      step: 0,
      showDayInfo: '',
      showDateInfo: '',
      timeTip: '',
      dialogVisible: false,
      visible: false,
      selectedTime: [],
      cascaderProps: {
        expandTrigger: 'hover',
        checkStrictly: false,
        value: 'id',
        label: 'label',
      },
      // 示例数据，实际使用时会被覆盖
      timeOptions: [],
      selectedCourse: this.isBatchBook ? this.courses[0] || {} : this.currentCourse,
      durationGroups: [],
      ruleContent: '',
      countdown: 0,
      // 课节选择相关数据
      periodId: '',
      lessonOptions: [],
      // 时间段选择相关数据
      selectedTimeSlot: '',
      timeSlotOptions: [],
    };
  },
  async created() {
    const isUpdateCourseRuleShowed = !!localStorage.getItem(UPDATE_COURSE_TIME_IDENTITY);
    if (!isUpdateCourseRuleShowed) {
      this.step = 0;
      // 写入标识
      localStorage.setItem(UPDATE_COURSE_TIME_IDENTITY, '1');
    } else {
      this.step = 1;
    }
    // 获取规则内容
    this.getRuleContent();
  },
  computed: {
    formattedTimeOptions() {
      // 将durationGroups转换为cascader需要的格式
      return this.durationGroups.map((group) => {
        return {
          id: group.start_date.toString(),
          label: group.start_date_des,
          children: group.cycle_durations.map((duration, i) => {
            return {
              id: `${duration.cycle}*${duration.start_time}*${duration.end_time}*${i}`,
              label: `${duration.cycle_des} ${duration.time_des}`,
              timeData: {
                cycle: duration.cycle,
                cycle_des: duration.cycle_des,
                end_time: duration.end_time,
                start_time: duration.start_time,
                time_des: duration.time_des,
              },
            };
          }),
        };
      });
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        // 使用nextTick确保DOM更新后再显示对话框，保留动画效果
        if (val) {
          this.$nextTick(() => {
            this.dialogVisible = true;
            if (this.bookStatus === BOOK_STATUS.BOOKED_NO_START) {
              this.step = 1;
            } else if (this.bookStatus === BOOK_STATUS.BOOKED_START) {
              if (this.step === 0) {
                this.showTitle = '调换上课时间规则';
                this.startCountdown();
              } else {
                this.step = 4;
              }
            }
            this.$webSeeSendTrack({
              event_id: 'course_period_switch_page_show',
            });
          });
        }
      },
    },
    selectedCourse: {
      immediate: true,
      async handler(val) {
        // 获取批量预约时间
        if (this.bookStatus === BOOK_STATUS.BOOKED_NO_START) {
          this.getDurationGroups(val);
        } else if (this.bookStatus === BOOK_STATUS.BOOKED_START) {
          this.courseId = val.course_id;
          this.getLessonPeriodsOptions(val);
        }
      },
    },
    periodId: {
      handler(val) {
        if (val) {
          // 重置时间选择
          this.selectedTimeSlot = '';
          this.getOneDurationOptions({
            courseId: this.selectedCourse.course_id,
            periodId: val,
          });
          this.$webSeeSendTrack({
            event_id: 'class_switch_period_button_click',
            event_type: 'click',
            data: {
              course_id: this.selectedCourse.course_id,
              period_id: val,
            },
          });
        }
      },
    },
  },
  methods: {
    handleTimeSelectChange() {
      this.$webSeeSendTrack({
        event_id: 'class_switch_time_button_click',
        event_type: 'click',
      });
    },
    async getLessonPeriodsOptions(course) {
      const res = await this.$http.get('/backend-api/app/study/appointment/one/periods', {
        courseId: course.course_id,
      });
      this.lessonOptions = res.periods.map((item) => {
        return {
          value: item.id,
          label: item.title,
        };
      });
      this.periodId = this.lessonOptions[0] && this.lessonOptions[0].value;
      // this.getOneDurationOptions({
      //   courseId: course.course_id,
      //   periodId: this.periodId,
      // });
    },
    async getOneDurationOptions(params) {
      const res = await this.$http.get('/backend-api/app/study/appointment/one/duration', params);
      this.timeSlotOptions = res.durations.map((item) => {
        return {
          value: `${item.start_date}*${item.start_time}*${item.end_time}*${item.start_date_des}*${item.time_des}`,
          label: `${item.start_date_des} ${item.time_des}`,
          timeData: {
            end_time: item.end_time,
            start_date: item.start_date,
            start_time: item.start_time,
          },
        };
      });
      this.restCount = res.rest_count;
      if (!this.timeSlotOptions.length) {
        this.timeTip = '当前课节没有可调换的时间段，请联系辅导老师更换时间';
      } else {
        this.timeTip = '';
      }
      if (this.restCount !== -1) {
        this.$webSeeSendTrack({
          event_id: 'course_period_switch_count_alert_show',
          data: {
            rest_count: this.restCount,
          },
        });
      }
    },
    async getRuleContent() {
      const res = await this.$http.get('/api/app/config/course_appointment');
      // this.ruleContent = res.course_appointment;
      // test data
      // const res = {
      //   course_appointment: '',
      // };
      this.ruleContent = res.course_appointment;
    },
    handleShowRule() {
      this.showTitle = '调换上课时间规则';
      this.step = 0;
      this.fromStep = 4;
    },
    async getDurationGroups(course) {
      // 不需要返回预约课程，0 不需要，1 需要
      const needUnAppointed = 0;
      const res = await this.$http.get('/backend-api/app/study/appointment/batch/duration', {
        courseId: course.course_id,
        needUnAppointed,
      });
      // test data
      this.timeTip = '';
      this.durationGroups = res.duration_groups;
      if (!this.durationGroups.length) {
        this.timeTip = '当前课程没有可调换的时间段';
      } else {
        this.timeTip = '';
      }
    },
    onCourseChange(course) {
      this.selectedCourse = course;
    },
    handleClosed() {
      switch (this.step) {
        case 0:
          this.$emit('update:show', false);
          // done();
          break;
        case 1:
          this.cancelStep1();
          break;
        case 2:
          this.cancelStep2();
          break;
        case 3:
          this.$emit('update:show', false);
          break;
        default:
          this.$emit('update:show', false);
          break;
      }
      return false;
    },
    cancelStep1() {
      this.$emit('update:show', false);
    },
    cancelStep2() {
      if (this.fromStep === 4) {
        this.step = 4;
        return;
      }
      this.step = 1;
    },
    cancelStep4() {
      this.$emit('update:show', false);
    },
    async confirmStep4() {
      if (!this.periodId || !this.selectedTimeSlot) return;

      const [start_date, start_time, end_time, start_date_des, time_des] =
        this.selectedTimeSlot.split('*');
      this.postBody = {
        course_id: this.selectedCourse.course_id,
        period_id: this.periodId,
        start_date,
        operation: BOOK_OPERATION.PRE_VALIDATE,
        start_time,
        end_time,
      };
      // 这里可以添加调用API的逻辑
      const res = await this.$http.post('/backend-api/app/study/appointment/one', this.postBody);

      // 模拟成功响应
      // const res = { fail_des: '周五 18:30-19:30', fail_type: BOOK_FAIL_TYPE.NO_FAIL };

      if (res.fail_type === BOOK_FAIL_TYPE.NO_FAIL) {
        this.timeTip = '';
        this.step = 2; // 跳转到成功页面
        this.showDayInfo = start_date_des;
        this.showDateInfo = `${time_des}`;
        this.fromStep = 4;
        this.showTitle = '确定上课时间';
      } else if (res.fail_type === BOOK_FAIL_TYPE.TIME_CONFLICT) {
        this.timeTip = `${res.fail_des} 您有其他课节上课，请更换时间`;
      } else {
        this.timeTip = '课程已开始无法调换全部上课时间';
      }
    },
    confirm() {
      if (this.countdown > 0) return;
      this.showTitle = '调换上课时间';
      // 查看触发
      if (this.fromStep === 4) {
        this.step = 4;
        return;
      }
      if (this.bookStatus === BOOK_STATUS.BOOKED_NO_START) {
        this.step = 1;
      } else if (this.bookStatus === BOOK_STATUS.BOOKED_START) {
        this.step = 4;
      }
      this.$webSeeSendTrack({
        event_id: 'class_switch_rule_explain_button_click',
        event_type: 'click',
      });
    },
    async confirmStep1() {
      if (!this.selectedTime.length) return;

      const [startDateId, combinValue] = this.selectedTime;
      // 查找选中的开始日期组和周期
      const startDateGroup = this.durationGroups.find(
        (group) => group.start_date.toString() === startDateId,
      );
      const cycleDuration = startDateGroup?.cycle_durations.find(
        (duration, i) =>
          `${duration.cycle}*${duration.start_time}*${duration.end_time}*${i}` === combinValue,
      );
      const [cycle] = combinValue.split('*');
      this.postBody = {
        course_id: this.selectedCourse.course_id,
        start_date: parseInt(startDateId),
        cycle,
        operation: BOOK_OPERATION.PRE_VALIDATE,
        end_time: cycleDuration.end_time,
        start_time: cycleDuration.start_time,
      };
      const res = await this.$http.post('/backend-api/app/study/appointment/batch', this.postBody);

      if (res.fail_type === BOOK_FAIL_TYPE.NO_FAIL) {
        this.timeTip = '';
        // 显示确认时间弹框
        this.step = 2;
        this.showDayInfo = startDateGroup.start_date_des;
        this.showDateInfo = `${cycleDuration.cycle_des}${cycleDuration.time_des}`;
        this.showTitle = '确定上课时间';
      } else if (res.fail_type === BOOK_FAIL_TYPE.TIME_CONFLICT) {
        this.timeTip = `${res.fail_des} 您有其他课节上课，请更换时间`;
      } else {
        this.timeTip = '课程已开始无法调换全部上课时间';
      }
    },
    async confirmStep2() {
      if (this.fromStep === 4) {
        const res = await this.$http.post('/backend-api/app/study/appointment/one', {
          ...this.postBody,
          operation: BOOK_OPERATION.BOOK,
        });
        // test data
        // const res = {
        //   fail_des: '周五 18:30-19:30',
        //   //
        //   fail_type: BOOK_FAIL_TYPE.NO_FAIL,
        // };
        if (res.fail_type === BOOK_FAIL_TYPE.NO_FAIL) {
          this.step = 3;
          this.showTitle = '调换上课时间';
          this.$emit('bookSuccess');
          this.$webSeeSendTrack({
            event_id: 'course_period_switch_success_page_show',
            data: {
              course_id: this.selectedCourse && this.selectedCourse.course_id,
            },
          });
        }
        return;
      }

      const res = await this.$http.post('/backend-api/app/study/appointment/batch', {
        ...this.postBody,
        operation: BOOK_OPERATION.BOOK,
      });
      // test data
      // const res = {
      //   fail_des: '周五 18:30-19:30',
      //   //
      //   fail_type: BOOK_FAIL_TYPE.NO_FAIL,
      // };
      if (res.fail_type === BOOK_FAIL_TYPE.NO_FAIL) {
        this.step = 3;
        this.showTitle = '调换上课时间';
        this.$emit('bookSuccess');
        this.$webSeeSendTrack({
          event_id: 'course_period_switch_success_page_show',
          data: {
            course_id: this.selectedCourse && this.selectedCourse.course_id,
          },
        });
      }
    },
    startCountdown() {
      this.countdown = 5;
      const timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(timer);
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .update-course-time-dialog {
  padding: 24px;
  border-radius: 16px !important;

  .time-cascader .el-input .el-input__inner {
    // background-color: #fafafa;
    height: 48px;
    border-radius: 8px;
    color: #1d1b20;
  }
  .time-cascader .el-input.is-disabled .el-input__inner {
    background-color: #fafafa;
  }
  .time-cascader {
    .el-input__suffix {
      right: 10px;
      .el-input__icon {
        font-weight: 900;
        color: #a6a6b1;
      }
    }
  }

  // 自定义select样式
  .lesson-select,
  .time-select {
    width: 100%;
    margin: 0;

    .el-input__inner {
      height: 48px;
      border-radius: 8px;
      color: #1d1b20;
    }

    .el-input__suffix {
      right: 10px;
      .el-input__icon {
        font-weight: 900;
        color: #a6a6b1;
      }
    }
  }

  .el-dialog__header {
    padding-top: 0;
    text-align: center;
    padding-bottom: 0;
    margin-bottom: 16px;
    font-weight: bolder;
  }

  .el-dialog__body {
    padding: 0;
    max-height: 486px;
  }
  .el-dialog__headerbtn {
    top: 25px;
  }
  .el-dialog__close.el-icon.el-icon-close {
    color: #54535c;
  }

  .book-course-name {
    padding-top: 16px;
    margin-bottom: 30px;
  }
  .book-course-time {
    .time-tip {
      margin-top: 4px;
      position: absolute;
      font-size: 12px;
      color: #ff2020;
      line-height: 22px;
    }
  }
  .period-tip {
    position: absolute;
    font-size: 12px;
    color: #8c8b97;
    line-height: 22px;
    .red-tip {
      color: #ff2020;
    }
  }

  .comfirm-time-cont {
    padding-top: 43px;
    padding-bottom: 11px;
    font-size: 16px;
    line-height: 22px;
    color: #35333a;
    text-align: center;
  }

  .book-success {
    text-align: center;
    padding-top: 42px;
    padding-bottom: 42px;
    font-size: 16px;
    line-height: 22px;
    color: #35333a;
    text-align: center;
    &-icon {
      margin-bottom: 16px;
      img {
        height: auto;
      }
    }
    &-text-title {
      line-height: 22px;
      font-size: 16px;
      font-weight: bolder;
      color: #1d1b20;
      margin-bottom: 8px;
    }
    &-text-desc {
      line-height: 20px;
      font-size: 14px;
      color: #8c8b97;
    }
  }
}

.update-course-content {
  h3 {
    padding: 0;
    margin: 0;
    font-size: 16px;
    color: #1e1c22;
    line-height: 22px;
    margin-bottom: 8px;
  }
  .rule-content {
    padding: 4px 24px 8px 8px;
    min-height: 187px;
    border-radius: 8px;
    margin-bottom: 53px;
    &-btn {
      text-align: center;
    }
  }
  .book-course-btn {
    padding: 14px 24px;
    font-size: 14px;
    border-radius: 40px;
  }
  .confirm-btn {
    background-color: #ff2020;
    border: none;
    box-shadow: 0px 0px 4px -2px rgba(24, 39, 75, 0.12), 0px 0px 4px -2px rgba(24, 39, 75, 0.08);
    &:hover {
      background-color: #e50000;
    }
  }
  .cancel-btn {
    width: 104px;
    color: #706e79;
    box-sizing: border-box;
    border: 1px solid #e1e2e9;
    box-shadow: 0px 0px 4px -2px rgba(24, 39, 75, 0.12), 0px 0px 4px -2px rgba(24, 39, 75, 0.08);
    border: 1px solid #e1e2e9;
    &:hover {
      background-color: #ffffff;
      color: #706e79;
    }
  }
  ::v-deep .el-button.is-disabled:not(.el-button--text),
  .el-button.is-disabled:focus:not(.el-button--text),
  .el-button.is-disabled:hover:not(.el-button--text) {
    background-color: #fcc !important;
    border: none !important;
    color: #fff !important;
    box-shadow: 0px 0px 4px -2px rgba(24, 39, 75, 0.12), 0px 0px 4px -2px rgba(24, 39, 75, 0.08);
  }
}
.time-cascader {
  width: 100%;
}

.dialog-footer {
  margin-top: 48px;
  text-align: right;
}
</style>

<style lang="scss">
/* 全局样式，不使用scoped，确保能影响弹出的popper */
.time-cascader-popper {
  min-width: 432px !important;
  width: 432px !important;
  box-sizing: border-box;
  margin-top: 4px !important;
  border-radius: 8px !important;
}

.time-cascader-popper {
  .el-cascader-node.in-active-path,
  .el-cascader-node.is-active {
    background-color: #ffefef;
  }
  // .el-cascader-node:not(.is-disabled):hover,
  // .el-cascader-node:not(.is-disabled):focus {
  //   background-color: #fafafa;
  //   color: #26212f;
  //   font-weight: 500;
  // }
  .el-cascader-node:not(.is-active):not(.in-active-path):hover,
  .el-cascader-node:not(.is-active):not(.in-active-path):focus {
    background-color: #fafafa;
    color: #26212f;
    font-weight: 500;
  }
}
.time-cascader-popper .el-cascader-menu {
  // width: 50%;
  color: #26212f;
  border-right: 1px solid #f1f3f9;
}

.time-cascader-popper .el-cascader-panel .el-cascader-menu:nth-child(1) {
  width: 44.3%;
}
.time-cascader-popper .el-cascader-panel .el-cascader-menu:nth-child(2) {
  width: 55.7%;
}

.time-cascader-popper .popper__arrow,
.update-course-time-popper .popper__arrow {
  display: none;
}
.el-popper.update-course-time-popper {
  margin-top: 4px;
  border-radius: 8px;
}
.update-course-time-popper {
  .el-select-dropdown__list {
    padding: 8px;
  }
  .el-select-dropdown__item {
    border-radius: 4px;

    padding: 0 8px;
    height: 32px;
    line-height: 32px;
    color: #26212f;
    &:hover {
      font-weight: bolder;
      background-color: #fafafa;
    }
    &.selected {
      font-weight: bolder;
      background-color: #ffefef;
      color: #ff2020;
    }
  }
}
</style>
